<template>
    <b-container fluid class="filtroSincronizacao"> 
        <!-- MODAL LISTA DE EMPRESAS VISUALIZAR NA TABELA / BTN TABELA VER -->
        <ModalLogDetalhado :datas="logDataModal" :pagination="LogsPage" :loading="loadingDetalhes" />
        <ConfigSincronizacaoModal />

        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="fa fa-sync"></i> Sincronização</span>
                <b-row>
                    <div class="col-lg-12 col-md-12 mt-2">
                        <container-card id="filtroSincronizacao" icon="fa-filter" title="Selecione as opções de sincronização.">
                            <el-form :model="model" :rules="rules" ref="formSincronizar" size="mini" label-position="top">
                                <b-card>
                                    <SelectMarcas v-model="model.marcas" />
                                    <b-form-row class="mb-2">
                                        <div class="col-lg-5 col-md-6">
                                            <b-form-row class="mb-0">
                                                <div class="col-lg-6 col-md-6">
                                                    <el-form-item label="Tipo de Regime" prop="tipoDeRegime">
                                                        <select2 :options="options" name="tipoDeRegimeSelect" v-model="model.tipoDeRegime"></select2>
                                                    </el-form-item>
                                                </div>
                                                <div class="col-lg-6 col-md-6">
                                                    <el-form-item label="Data início/fim" prop="Month" required>
                                                        <el-date-picker v-model="model.Month"
                                                            type="monthrange"
                                                            range-separator="|"
                                                            start-placeholder="Início"
                                                            end-placeholder="Fim"
                                                            format="MM/yyyy"
                                                            size="small"
                                                            class="w-100">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </b-form-row>
                                        </div>
                                        <div class="col-lg-7 col-md-6">
                                            <el-form-item required :label="`Empresas${model.clusterEmpresaBool ? ' (Cluster)' : ''}:`" label-for="empresasASelect" :prop="model.clusterEmpresaBool ? 'clustersEmpresasIds' : 'EmpresasIds'">
                                                <div class="toogle-multiselect-cluster">
                                                    <small class="label-toogle-cluster">{{ model.clusterEmpresaBool ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                                    <el-switch v-b-popover.hover.top="'Alternar combo clusters/empresas.'"
                                                                v-model="model.clusterEmpresaBool"></el-switch>
                                                </div>
                                                <div v-show="model.clusterEmpresaBool == false">
                                                    <custom-select-multiple 
                                                      v-if="isRerender"
                                                      v-model="model.EmpresasIds"
                                                      :url="`${$urls.EMPRESAS}?marcas=${model.marcas}`"
                                                      group 
                                                      />
                                                </div>
                                                <div v-show="model.clusterEmpresaBool == true">
                                                    <custom-select-multiple
                                                      v-if="isRerender"
                                                      v-model="model.clustersEmpresasIds"
                                                      :url="$urls.DRE_LISTA_CLUSTER"
                                                    />
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-7 col-md-12" v-if="isAdminF360()">
                                            <b-form-checkbox v-model="model.processarParcelaDeCartao"><small>Processar parcelas de cartão</small></b-form-checkbox>
                                            <b-form-checkbox v-model="model.processarParcelaDeTitulo"><small>Processar parcelas de títulos</small></b-form-checkbox>
                                            <b-form-checkbox v-model="model.processarDiferencaDeCaixa"><small>Processar diferença de caixa</small></b-form-checkbox>
                                            <b-form-checkbox v-model="model.processarValoresManuaisDaDRE"><small>Processar valores manuais da DRE</small></b-form-checkbox>
                                        </div>
                                        <div v-if="configSincronizacao && configSincronizacao.ativo === true" class="col-lg-4 col-md-8">
                                            <b-card class="sinc-container" bg-variant="light" style="font-size: 0.8em;">
                                                <span class="status-limit active" title="Data de corte por competência está ativada"></span>
                                                
                                                <el-popover
                                                    placement="top-start"
                                                    title="Data limite de competência"
                                                    width="340"
                                                    trigger="hover"
                                                    content="Sincronização configurada com uma data limite de competência, suas sincronizações só obterão dados a partir da respectiva data selecionada.">
                                                    <span slot="reference" class="status-helper">
                                                        <i class="fa fa-question"></i>
                                                    </span>
                                                </el-popover>

                                                
                                                <el-form-item label="Data de corte da Sincronização ativada">
                                                    <el-date-picker
                                                        required
                                                        v-model="configSincronizacao.dataLimite"
                                                        type="month"
                                                        format="MM/yyyy"
                                                        size="small"
                                                        class="w-100"
                                                        disabled
                                                    >
                                                    </el-date-picker>
                                                </el-form-item>
                                            </b-card>
                                        </div>
                                    </b-form-row>
                                    <div slot="footer" v-if="temAcesso('Sincronizacao','Criar')">
                                        <div class="float-left btn-pesquisar">
                                            <el-button size="small" @click.prevent="gerarSincronizacao" :loading="loading" type="primary" icon="el-icon-refresh">Sincronizar</el-button>
                                            <el-button size="small" @click.prevent="limpar" icon="el-icon-brush">Limpar</el-button>
                                        </div>
                                        
                                        <div class="float-right" v-if="premiumUser()">
                                            <el-button size="small" v-b-modal.modal-config-sincronizacao type="info" icon="el-icon-s-tools">
                                                Configuração de Sincronização
                                            </el-button>
                                        </div>
                                        <div class="float-right" v-else="premiumUser()">
                                            <el-button size="small" disabled type="info" title="Funcionalidade premium" icon="el-icon-s-tools">
                                                Configuração de Sincronização
                                            </el-button>
                                        </div>
                                    </div>
                                    <div slot="footer" v-else>
                                        <div class="float-left btn-pesquisar">
                                            <b-button style="width:100px;" disabled size="sm" class="mr-2 no-drop" v-b-tooltip.hover title="Sem permissões">Sincronizar</b-button>
                                        </div>
                                    </div>
                                </b-card>
                            </el-form>
                        </container-card>
                        <div :class="showListLog ? 'd-block' : 'd-none'">
                            <container-card fixed id="LogsSincronizacao" icon="fa-th-list" title="Log de sincronização em processamento.">
                                <b-card>
                                    <el-button 
                                        class="float-right recarregar-btn" 
                                        circle 
                                        size="mini"
                                        @click="listarProcessando"
                                        v-b-popover.hover.top="'Recarregar Logs em processamento'">
                                        <i class="fas fa-sync-alt"></i>
                                    </el-button>
                                    <!-- TABLE -->
                                    <el-table
                                        class="p-table"
                                        v-loading="loadingProcessando"
                                        :data="tableDataProcessando"
                                        stripe
                                        style="width: 100%;"
                                        border
                                        size="mini"
                                        >
                                        
                                        <el-table-column
                                            prop="referenciaExterna"
                                            label="Número"
                                            align="center"
                                            width="150">
                                        </el-table-column>
                                        <el-table-column
                                            prop="createdAt"
                                            label="Data de criação">
                                            <template slot-scope="scope" v-if="scope.row">
                                                {{ scope.row.createdAt ? moment(scope.row.createdAt).format('DD/MM/YYYY') : '' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="inicioProcessamento"
                                            label="Data de início">
                                            <template slot-scope="scope" v-if="scope.row">
                                                {{ scope.row.inicioProcessamento ? moment(scope.row.inicioProcessamento).format('DD/MM/YYYY') : '' }}
                                            </template>
                                        </el-table-column>
                                        
                                        <el-table-column
                                            prop="porcentagemDeConclusao"
                                            label="Andamento"
                                            align="center"
                                            width="150">
                                        </el-table-column>

                                        <el-table-column
                                            label="Log completo"
                                            align="center"
                                            width="150"
                                        >
                                            <template slot-scope="scope" v-if="scope.row">
                                                <el-button round icon="el-icon-view" @click="mostrarLogsDetalhados(scope.row._id)" v-b-modal.modal-log-detalhado size="mini">Log Detalhado</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            fixed="right"
                                            label="Status"
                                            width="70"
                                            align="center">
                                            <template slot-scope="scope" v-if="scope.row">
                                                <el-tooltip v-if="scope.row.status.value == 0" class="item" effect="dark" content="Status: Aguardando" placement="top-start">
                                                    <i class="fas fa-circle text-warning"></i>
                                                </el-tooltip>
                                                <el-tooltip v-if="scope.row.status.value == 1" class="item" effect="dark" content="Status: Processando" placement="top-start">
                                                    <i class="fas fa-circle text-primary"></i>
                                                </el-tooltip>
                                                <el-tooltip v-if="scope.row.status.value == 2" class="item" effect="dark" content="Status: Finalizado" placement="top-start">
                                                    <i class="fas fa-circle text-success"></i>
                                                </el-tooltip>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </b-card>
                            </container-card>
                        </div>
                    </div>
                </b-row>
            </el-tab-pane>

            <!-- ABA 2 -->
            <el-tab-pane>
                <span slot="label" v-if="temAcesso('Sincronizacao','Obter')"><i class="fas fa-list"></i> sincronizações finalizadas</span>
                <div>
                    <div :class="showListLog ? 'd-block' : 'd-none'">
                        <container-card fixed id="LogsSincronizacao" icon="fa-th-list" title="Log de sincronização.">
                            <b-card>
                                <el-button 
                                    class="float-right recarregar-btn" 
                                    circle 
                                    size="mini"
                                    @click="listarFinalizados"
                                    v-b-popover.hover.top="'Recarregar Logs Finalizados'">
                                    <i class="fas fa-sync-alt"></i>
                                </el-button>
                                <!-- TABLE -->
                                <el-table
                                    class="p-table"
                                    v-loading="loadingFinalizados"
                                    :data="tableDataFinalizados"
                                    stripe
                                    style="width: 100%;"
                                    border
                                    size="mini"
                                    >
                                    
                                    <el-table-column
                                        prop="referenciaExterna"
                                        label="Número"
                                        align="center"
                                        width="150">
                                    </el-table-column>
                                    <el-table-column
                                        prop="createdAt"
                                        label="Data de criação">
                                        <template slot-scope="scope" v-if="scope.row">
                                            {{ scope.row.createdAt ? moment(scope.row.createdAt).format('DD/MM/YYYY') : '' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="inicioProcessamento"
                                        label="Data de início">
                                        <template slot-scope="scope" v-if="scope.row">
                                            {{ scope.row.inicioProcessamento ? moment(scope.row.inicioProcessamento).format('DD/MM/YYYY') : '' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="fimProcessamento"
                                        label="Data de fim">
                                        <template slot-scope="scope" v-if="scope.row">
                                            {{ scope.row.fimProcessamento ? moment(scope.row.fimProcessamento).format('DD/MM/YYYY') : '' }}
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column
                                        label="Log completo"
                                        align="center"
                                        width="150"
                                    >
                                        <template slot-scope="scope" v-if="scope.row">
                                            <el-button round icon="el-icon-view" @click="mostrarLogsDetalhados(scope.row._id)" v-b-modal.modal-log-detalhado size="mini">Log Detalhado</el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        label="Status"
                                        width="70"
                                        align="center">
                                        <template slot-scope="scope" v-if="scope.row">
                                            <el-tooltip v-if="scope.row.status.value == 0" class="item" effect="dark" content="Status: Aguardando" placement="top-start">
                                                <i class="fas fa-circle text-warning"></i>
                                            </el-tooltip>
                                            <el-tooltip v-if="scope.row.status.value == 1" class="item" effect="dark" content="Status: Processando" placement="top-start">
                                                <i class="fas fa-circle text-primary"></i>
                                            </el-tooltip>
                                            <el-tooltip v-if="scope.row.status.value == 2" class="item" effect="dark" content="Status: Finalizado" placement="top-start">
                                                <i class="fas fa-circle text-success"></i>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </b-card>
                        </container-card>
                    </div>
                </div>
            </el-tab-pane>
            
            <el-tab-pane>
                <span slot="label"><i class="fa fa-sitemap"></i> Mapeamento Retroativo </span>
                <MapeamentoRetroativo />
                <!-- <container-card fixed id="mapeamentoRetroativo" icon="fa-sitemap" title="Mapeamento">
                    <b-card>
                        <MapeamentoRetroativo />
                    </b-card>
                </container-card> -->
            </el-tab-pane>
        </el-tabs>
    </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2Multiple from '@/components/shared/Select2Multiple'
import Select2 from '@/components/shared/Select2'
import ModalLogDetalhado from '@/views/Sincronizacao/ModalLogDetalhado'
import ConfigSincronizacaoModal from '@/views/Sincronizacao/ConfigSincronizacaoModal'
import MapeamentoRetroativo from '@/views/Sincronizacao/MapeamentoRetroativo'
import SelectMarcas from '@/components/shared/SelectMarcas'

const listas = () => {
    return {
        modelosDRE: [],
        empresas: [],
        cluster: []
    }
}

const model = () => {
    return {
        EmpresasIds: [],
        dataInicio: '',
        dataFim: '',
        Month: '',
        clusterEmpresaBool: false,
        clustersEmpresasIds: [],
        tipoDeRegime: '',
        marcas: [],
        processarParcelaDeCartao: true,
        processarParcelaDeTitulo: true,
        processarDiferencaDeCaixa: true,
        processarValoresManuaisDaDRE: true
    }
}

export default {
    components: {
        ContainerCard,
        Select2Multiple,
        Select2,
        ModalLogDetalhado,
        ConfigSincronizacaoModal,
        MapeamentoRetroativo,
        SelectMarcas
    },
    name: 'sincronizacao',
    data() {
        return {
            loading: false,
            loadingFinalizados: false,
            loadingProcessando: false,
            loadingDetalhes: false,
            model: model(),
            listas: listas(),
            tableDataProcessando: [],
            tableDataFinalizados: [],
            logDataModal: [],
            isRerender: true,
            showListLog: true,
            options: [{
                id: 1,
                label: 'Competência'
            }, {
                id: 2,
                label: 'Data do Caixa'
            }],
            rules: {
                //tipoDeRegime: [
                //    { required: true, message: 'Selecione o regime para sincronizar', trigger: 'change' }
                //],
                Month: [
                    { required: true, message: 'Por favor, escolha um período', trigger: 'change' }
                ],
                EmpresasIds: [
                    { type: 'array', required: true, message: 'Por favor, escolha uma empresa', trigger: 'change' }
                ],
                clustersEmpresasIds: [
                    { type: 'array', required: true, message: 'Por favor, escolha um cluster', trigger: 'change' }
                ]
            },
            LogsPage: {
                page: 0,
                pageSize: 10
            },
            configSincronizacao: {}
        }
    },
    methods: {
        colorTag (data) {
            switch(data.value) {
                case 0: return 'warning'
                case 1: return 'primary'
                case 2: return 'success'
                default: return ''
            }
        },
        isAdminF360(){
            const getUser = JSON.parse(localStorage.getItem('user')) || ''
            return getUser && getUser.user.f360Admin
        },
        limpar() {
            this.model = model()
        },
        gerarSincronizacao() {
            this.loading = true

            this.$refs['formSincronizar'].validate((valid) => {
                if (!valid) {
                    this.loading = false
                    return false;
                }

                this.trackingF360(this, 'Sincronização', 'Sincronizar');
                this.sincronizar()
            });
        },
        logErro() {
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
        },
        async sincronizar() {
            this.loading = true;

            console.log("Model: ", this.model);

            try {
                const response = await this.axios.post(this.$urls.CRIAR_SINCRONIZACAO, this.model);

                if (response.status !== 200) {
                    throw new Error('Erro na solicitação');
                }

                this.$notify({
                    type: "success",
                    title: 'Sincronização iniciada',
                    message: 'Sua sincronização está sendo processada'
                });

                this.listarProcessando();
            } catch (error) {
                //this.logErro(error);
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        async listarProcessando() {
            this.loadingProcessando = true;

            try {
                const response = await this.axios.get(this.$urls.LISTAR_SINCRONIZACAO_PROCESSANDO);

                if (response.status !== 200) {
                    throw new Error('Erro na solicitação');
                }

                this.tableDataProcessando = response.data;
            } catch (error) {
                this.logErro(error);
            } finally {
                this.loadingProcessando = false;
            }
        },
        async listarFinalizados() {
            this.loadingFinalizados = true;

            try {
                const response = await this.axios.get(this.$urls.LISTAR_SINCRONIZACAO_FINALIZADOS);

                if (response.status !== 200) {
                    throw new Error('Erro na solicitação');
                }

                this.tableDataFinalizados = response.data;
            } catch (error) {
                this.logErro(error);
            } finally {
                this.loadingFinalizados = false;
            }
        },
        async obterAtualizados(id) {
            this.loadingDetalhes = true;

            try {
                const response = await this.axios.get(`${this.$urls.OBTER_ATUALIZADOS}`, { params: { _id: id, ...this.LogsPage } });

                if (response.status !== 200) {
                    throw new Error('Erro na solicitação');
                }

                this.logDataModal = response.data;
                this.logDataModal.id = id;
                this.$bvModal.show('modal-log-detalhado');
            } catch (error) {
                this.logErro(error);
            } finally {
                this.loadingDetalhes = false;
            }
        },
        mostrarLogsDetalhados(id){
            this.obterAtualizados(id);
            this.$bvModal.show('modal-log-detalhado');
        },
        async getConfigSincronizacao() {
            let response = await this.axios.get(this.$urls.OBTER_CONFIG_SINCRONIZACAO)

            if (response.status !== 200) {
                return;
            }

            this.configSincronizacao = response.data;
        },
    },
    watch: {
        'model.Month': function(val) {
            let hasVal = !this.isNullOrEmpty(val);

            this.model.dataInicio = hasVal ? this.moment(val[0]).format('YYYY-MM-DD') : ''
            this.model.dataFim = hasVal ? this.moment(val[1]).format('YYYY-MM-DD') : ''
        },
        'model.clusterEmpresaBool': function(val) {
            let empresaRule = this.rules.EmpresasIds[0]; 
            let clusterRule = this.rules.clustersEmpresasIds[0];
            
            empresaRule.required = val ? false : true;
            clusterRule.required = val ? true : false;
            
        },
        'model.EmpresasIds'() {
            this.$refs['formSincronizar'].validateField('EmpresasIds');
        },
        'model.clustersEmpresasIds'() {
            this.$refs['formSincronizar'].validateField('clustersEmpresasIds');
        },
        'model.marcas'() { // sempre que marcas for alterado, redesenha o select de empresas
            this.isRerender = false;
            this.$nextTick(()=>{ 
                this.listas.empresas = []
                this.isRerender = true;
            });
        }
    },
    mounted() {
        this.listarFinalizados();
        this.listarProcessando();
        this.getConfigSincronizacao();

        this.$root.$on('paginationDetalheCurrent', (val) => {
            this.LogsPage.page = val.p;
            this.obterAtualizados(val.id);
        });
        this.$root.$on('paginationDetalheSize', (val) =>{
            this.LogsPage.pageSize = val.p;
            this.obterAtualizados(val.id);
        });
    }
}
</script>
<style lang="scss">
    .sinc-container {
        position:relative;
        .status-limit {
            position:absolute;
            top: 10px;
            right: 12px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid;
            border-color: #ccc;
            background-color:#eee;
            &.active {
               border-color: #09b141;
                background-color:#15d656; 
            }
        }
        .status-helper {
            position: absolute;
            top: 39%;
            right: 15px;
            border-radius: 50%;
            border: 1px solid #adadad;
            cursor: pointer;
            z-index: 2;
            font-size: 14px;
            padding: 1px 8px 2px 7px;
            color: #007bff;
        }
        .card-body {
            padding: 0px 12px !important;
        }
    }
    .recarregar-btn {
        position:absolute;
        right: 11px;
        z-index: 10;
        top: -34px;
    }
</style>
<style>
/* fix estilos com form el */
.filtroSincronizacao .toogle-multiselect-cluster {
    position:absolute;
    top: -31px;
    right:0;
}
.filtroSincronizacao .el-form--label-top .el-form-item__label {
    padding: 0 0 0;
}
.filtroSincronizacao div span.select2-container .select2-search--inline .select2-search__field {
    margin: 0px 5px !important;
}
</style>
